export const environment = {
  production: false,
  // apiBaseUrl: 'http://localhost:3010/api',
  // socketUrl: 'http://localhost:3010',
  // socketPath: '/api/socket.io'
  apiBaseUrl: 'https://srv748061.hstgr.cloud/api',
  socketUrl: 'https://srv748061.hstgr.cloud',
  socketPath: '/api/socket.io'
};
